import { FC } from 'react';

import {
  DividerProps as MantineDividerProps,
  Divider as MantineDivider,
  MantineColor,
  useMantineColorScheme
} from '@mantine/core';

interface DividerProps extends MantineDividerProps {
  darkColor?: MantineColor;
  lightColor?: MantineColor;
}

const Divider: FC<DividerProps> = ({ darkColor, lightColor, color, ...rest }) => {
  const scheme = useMantineColorScheme();
  let finalColor = color
    ? color
    : scheme.colorScheme === 'light'
    ? 'secondary.2'
    : 'dark.4';
  finalColor =
    scheme.colorScheme === 'light'
      ? lightColor
        ? lightColor
        : finalColor
      : darkColor
      ? darkColor
      : finalColor;
  return <MantineDivider {...rest} color={finalColor} />;
};

export { Divider };
export type { DividerProps };
